import { DocCenterData, HelpLink } from '../typings/doc-center';

export const OPEN_HELP = 'OPEN_HELP';
export type OPEN_HELP = typeof OPEN_HELP;

export interface OpenHelp {
    type: OPEN_HELP;
    id: HelpLink;
}

export function openHelp(id: HelpLink): OpenHelp {
    return {
        type: OPEN_HELP,
        id
    };
}

export const UPDATE_HELP = 'UPDATE_HELP';
export type UPDATE_HELP = typeof UPDATE_HELP;

export interface UpdateHelp {
    type: UPDATE_HELP;
    id: HelpLink;
}

export function updateHelp(data: DocCenterData): UpdateHelp {
    return {
        type: UPDATE_HELP,
        id: data.id as HelpLink
    };
}

export const CLOSE_HELP = 'CLOSE_HELP';
export type CLOSE_HELP = typeof CLOSE_HELP;

export interface CloseHelp {
    type: CLOSE_HELP;
}

export const closeHelp: CloseHelp = {
    type: CLOSE_HELP
};

export type HelpAction = OpenHelp | UpdateHelp | CloseHelp;
